import type { FC } from 'react'
import { useRecentAudits } from '../../../hooks'
import { HoverCard, HoverCardContent, HoverCardTrigger } from '@bpinternal/ui-kit-next'
import { UserAvatar } from '../../../componentsV2'
import { auditMessages } from '../../audits/components'
import type { Action } from '../../audits/types'
import { History, StyledLink } from '~/elementsv2'

type Props = {
  workspaceId: string
  count?: number
}
export const AuditsPreview: FC<Props> = ({ count = 3, workspaceId }) => {
  const audits = useRecentAudits(workspaceId).data.slice(0, count)
  const historyItems = audits.map((audit, index) => {
    return {
      timelinePointElement: audit.userEmail && (
        <HoverCard>
          <HoverCardTrigger>
            <UserAvatar size={'1'} userId={audit.userId ?? undefined} workspaceId={workspaceId} />
          </HoverCardTrigger>
          <HoverCardContent side="top" className="w-fit">
            <div className="flex items-center gap-2">
              <UserAvatar size={'2'} userId={audit.userId ?? undefined} workspaceId={workspaceId} />
              <span className="text-sm font-medium text-gray-12">{audit.userEmail}</span>
            </div>
          </HoverCardContent>
        </HoverCard>
      ),
      content: (
        <div className="flex flex-col gap-4">
          <span className="text-xs">
            {(auditMessages[audit.action as Action] ?? auditMessages.UNKNOWN).render(audit)}
          </span>
          {index === audits.length - 1 ? (
            <StyledLink className="text-xs" to="/workspaces/$workspaceId/settings/audits" params={{ workspaceId }}>
              View all audits
            </StyledLink>
          ) : null}
        </div>
      ),
      timestamp: audit.recordedAt,
    }
  })

  return (
    <div className="flex flex-col gap-4">
      <span className="text-sm font-medium">Recent changes</span>
      <History items={historyItems} />
    </div>
  )
}
